module.exports = __webpack_public_path__ + "static/media/cover-theater.5602b39e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cover-theater.jpg
// module id = 213
// module chunks = 0